import { render, staticRenderFns } from "./InvoiceNotesModal.vue?vue&type=template&id=42979bb0&"
import script from "./InvoiceNotesModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports